import axios from 'axios'
import { CLIENTES } from '../conexiones';
import { allClientes, clienteId, clienteNew } from './clientesSlice';

export const getAllClientes = () => {
    return async (dispatch) => {
        try {
            await axios.get(CLIENTES)
            .then(res => dispatch(allClientes(res.data)))            
        } catch (error) {
            console.log(error);            
        }        
    }
}

export const getClienteId = (id) => {
    return async (dispatch) => {
        try {
            await axios.get(`${CLIENTES}/${id}`)
            .then(res => dispatch(clienteId(res.data)))            
        } catch (error) {
            console.log(error);            
        }        
    }
}

export const postCliente = (payload) => {
    return async (dispatch) => {
        try {
            await axios.post(CLIENTES, payload)
            .then(res => dispatch(clienteNew(res.data)))
        } catch (error) {
            console.log(error);            
        }
    }
}